import { createSlice } from '@reduxjs/toolkit';
import { saveToSessionStorage, StorageKey } from '../../storage/SessionStorage';

const defaultState = {
    username: '1',
    roles: '2',
    jwtToken: '3',
};

const LoginSlice = createSlice({
    name: 'login',
    initialState: defaultState,
    reducers: {
        saveLogin(state, { payload }) {
            saveToSessionStorage(StorageKey.jwt, payload.jwtToken);
            saveToSessionStorage(StorageKey.roles, payload.roles);
            saveToSessionStorage(StorageKey.fullName, payload.fullName);
            return {
                fullName: payload.fullName,
                roles: payload.roles,
            };
        },
    },
});

export default LoginSlice.reducer;
export const { saveLogin } = LoginSlice.actions;
